function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "4.083,16.009 14.097,4.582    67.583,4.582 77.598,16.009 77.598,111.555 67.583,122.982 14.097,122.982 4.083,111.555  "
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 14.097,
  y1: 4.699,
  x2: 23.993,
  y2: 18.365
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 4.083,
  y1: 15.891,
  x2: 19.398,
  y2: 23.078
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 67.583,
  y1: 4.699,
  x2: 57.688,
  y2: 18.365
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 77.598,
  y1: 15.891,
  x2: 62.281,
  y2: 23.078
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 67.583,
  y1: 122.864,
  x2: 57.688,
  y2: 109.198
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 77.598,
  y1: 111.673,
  x2: 62.281,
  y2: 104.486
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 14.097,
  y1: 122.864,
  x2: 23.993,
  y2: 109.198
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  x1: 4.083,
  y1: 111.673,
  x2: 19.398,
  y2: 104.486
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "9.267,18.248 17.514,9.176    64.167,9.176 72.413,18.248 72.413,109.316 64.167,118.387 17.514,118.387 9.267,109.316  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "14.45,20.722 20.694,13.771    60.984,13.771 67.229,20.722 67.229,106.842 60.984,113.793 20.694,113.793 14.45,106.842  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "19.398,23.137 23.993,18.424    57.688,18.424 62.281,23.137 62.281,104.427 57.688,109.141 23.993,109.141 19.398,104.427  "
}));

const SvgEmerald = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  x: "0px",
  y: "0px",
  width: "82px",
  height: "127px",
  viewBox: "0 0 82 127",
  enableBackground: "new 0 0 82 127",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmerald, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/emerald.924dfed9.svg";
export { ForwardRef as ReactComponent };